export default __webpack_public_path__ + "static/media/LandBeforeTime_01.86fb0d80.png";